import React from 'react'

const EnvelopIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='23'
    viewBox='0 0 24 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.5787 3.83838H4.42129C3.37637 3.83838 2.52661 4.68814 2.52661 5.73306V17.1011C2.52661 18.146 3.37637 18.9958 4.42129 18.9958H19.5787C20.6236 18.9958 21.4734 18.146 21.4734 17.1011V5.73306C21.4734 4.68814 20.6236 3.83838 19.5787 3.83838ZM19.5787 5.73306V6.21715L12 12.1124L4.42129 6.21809V5.73306H19.5787ZM4.42129 17.1011V8.61676L11.4183 14.0592C11.5842 14.1895 11.7891 14.2604 12 14.2604C12.2109 14.2604 12.4158 14.1895 12.5817 14.0592L19.5787 8.61676L19.5806 17.1011H4.42129Z'
      fill='currentColor'
    />
  </svg>
)

export default EnvelopIcon
